import React, {useState} from 'react';
import {useMultichatFunnels} from '../../../../../funnels/utils';
import {
  ButtonBase,
  makeStyles,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import {colors} from '../../../../../../../assets/styles/colors';
import CustomModal from '../../../../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../../../../elements/CustomButton/CustomButton';

import {useCurrentConversationActions} from '../../../../utils/conversation';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  funnelButton: {
    padding: '.5rem',
    borderRadius: '.5rem',
    background: colors.lightPurple,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    fontSize: '1rem',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  subtitle: {
    color: colors.grey600,
    fontSize: 14,
    fontWeight: 500,
  },
  currentFunnel: {
    padding: '.5rem',
    borderRadius: '.5rem',
    background: colors.purple,
    color: 'white',
    width: '100%',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 600,
    textAlign: 'center',
    color: colors.grey900,
  },

  modalSubtitle: {
    fontSize: 16,
    color: colors.grey700,
  },
  modalButton: {
    margin: '0 auto',
  },
  modalContainer: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
  },
}));

export type FunnelSectionProps = {
  conversationFunnel?: string,
  conversationId: string,
};

export default function FunnelSection({
  conversationFunnel,
  conversationId,
}: FunnelSectionProps) {
  const classes = useStyles();
  const {funnels} = useMultichatFunnels();

  const [funnelSelected, setFunnelSelected] = useState(null);
  const [funnelLaneSelected, setFunnelLaneSelected] = useState(null);

  const {setConversationFunnel} = useCurrentConversationActions();

  const handleCloseModal = () => {
    setFunnelSelected(null);
    setFunnelLaneSelected(null);
  };

  const handleConfirmModal = () => {
    if (!funnelSelected || !funnelLaneSelected) return;
    setConversationFunnel(
      funnelSelected.id,
      funnelSelected.name,
      funnelLaneSelected.id
    ).then(() => handleCloseModal());
  };

  if (!funnels?.length) return null;

  const availableFunnels = funnels.filter(
    funnel => !conversationFunnel || funnel.name !== conversationFunnel
  );

  return (
    <div className={classes.container}>
      {conversationFunnel && (
        <>
          <span className={classes.subtitle}>Embudo actual:</span>
          <div className={classes.currentFunnel}>{conversationFunnel}</div>
        </>
      )}
      {availableFunnels.length > 0 && (
        <>
          <span className={classes.subtitle}>
            {conversationFunnel ? 'Cambiar embudo:' : 'Seleccionar embudo:'}
          </span>

          {availableFunnels.map(funnel => (
            <ButtonBase
              key={funnel.id}
              className={classes.funnelButton}
              onClick={() => setFunnelSelected(funnel)}
            >
              {funnel.name}
            </ButtonBase>
          ))}
        </>
      )}

      <CustomModal open={!!funnelSelected} handleCloseModal={handleCloseModal}>
        <div className={classes.modalContainer}>
          <Typography className={classes.modalTitle}>
            Embudo: {funnelSelected?.name}
          </Typography>

          <Typography className={classes.modalSubtitle}>
            Selecciona una columna para la conversación
          </Typography>

          <RadioGroup aria-label="columna" name="funnelLane">
            {funnelSelected?.lanes.map(lane => (
              <FormControlLabel
                key={lane.id}
                value={lane.id}
                control={<Radio color="primary" />}
                label={lane.stage.label}
                onClick={() => setFunnelLaneSelected(lane)}
              />
            ))}
          </RadioGroup>

          <CustomButton
            className={classes.modalButton}
            variant="contained"
            onClick={handleConfirmModal}
            disabled={!funnelLaneSelected}
          >
            {funnelLaneSelected ? 'Cambiar embudo' : 'Seleccionar columna'}
          </CustomButton>
        </div>
      </CustomModal>
    </div>
  );
}
